import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  DialogActions,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import CustomButton from "../custom-button/CustomButton";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string | React.ReactNode;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  body,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: { 
          borderRadius: "1.25rem",
          width: isDesktop ? '80%' : '100%',
          maxWidth: isDesktop ? 800 : 'none',
        },
      }}
      fullWidth
    >

      <DialogTitle sx={{ 
        fontSize: { xs: '1.2rem', md: '1.6rem' },
        py: { xs: 2, md: 3 }
      }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <strong>{title}</strong>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent sx={{ py: { xs: 2, md: 3 } }}>
        {typeof body === "string" ? (
          <Typography 
            variant="body1"
            sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, lineHeight: 1.6 }}
          >
            {body}
          </Typography>
        ) : (
          body
        )}
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, md: 3 } }}>
        <CustomButton text="Zamknij" onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
